import React from 'react';
import { EventDetailsMainInner } from '../../../EventDetails/EventDetails';
import { OrganizerTrustSignalInfo } from '../OrganizerTrustSignalInfo/OrganizerTrustSignalInfo';

import { LISTING_HEAP_PAGE_AREA_IDS } from '../../../../constants';
import type { FeatureFlags } from '../../../../types';

export interface OrganiserListingPageProps {
    isMobile?: boolean;
    featureFlags?: FeatureFlags;
    pageArea?: string;
}

const OrganiserListingPage = ({
    featureFlags,
    isMobile,
    pageArea = LISTING_HEAP_PAGE_AREA_IDS.SIMPLIFIED_ORGANIZER,
}: OrganiserListingPageProps) => {
    return (
        <EventDetailsMainInner>
            <div data-testid="creator-signal-main-section">
                <OrganizerTrustSignalInfo
                    pageArea={pageArea}
                    featureFlags={featureFlags}
                    isMobile={isMobile}
                />
            </div>
        </EventDetailsMainInner>
    );
};

export default OrganiserListingPage;
